import React, { ComponentProps, PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog"
import { cn } from '@/lib/utils';


type AlertDialogProps = ComponentProps<typeof AlertDialog> & {
  trigger?: ComponentProps<typeof AlertDialogTrigger>
  content?: Omit<ComponentProps<typeof AlertDialogContent>, 'children'>
  header?: Omit<ComponentProps<typeof AlertDialogHeader>, 'children'> 
  // & {
  //   title?: string, 
  //   titleProps?: Omit<ComponentProps<typeof Text>, 'children'>
  //   desc?: string,
  //   descProps?: Omit<ComponentProps<typeof Text>, 'children'>,
  //   children?: React.ReactNode | string
  // }
  headerTitle?: ComponentProps<typeof AlertDialogTitle>
  headerDesc?: ComponentProps<typeof AlertDialogDescription>
  footer?: ComponentProps<typeof AlertDialogFooter>
  showCancel?: boolean,
  cancelText?: string,
  confirmText?: string,
  onAction?: (action: boolean) => void
}

export const CardAlert: React.FC<PropsWithChildren<AlertDialogProps>> = ({
  children,
  trigger,
  header,
  headerTitle,
  headerDesc,
  footer,
  content,
  onAction,
  showCancel,
  cancelText,
  confirmText,
  ...rest 
}) => {
  const { t } = useTranslation()
  const { children: triggerChildren, ...triggerProps } = trigger || {}

  const { className: contentClassName, ...contentProps } = content || {}
  const handleAction = (action: boolean) => {
    if (onAction) {
      onAction(action)
    }
  }

  return (
    <AlertDialog
      {...rest}
    >
      {
        triggerChildren && (
          <AlertDialogTrigger {...triggerProps}>
            {triggerChildren}
          </AlertDialogTrigger>
        )
      }

      <AlertDialogContent
        {...contentProps}
        className={cn(
          'w-[90%] max-w-[400px] text-center text-sm !rounded-[2px] border p-3 xl:text-left [&>button]:hidden',
          contentClassName
        )}
      >
        <AlertDialogHeader
          {...header}
          // style={{display: header || headerTitle || headerDesc  ? 'block' : 'none'}}
          className={cn('font-Orbitron text-lg', header?.className)}
        >
          <AlertDialogTitle  {...headerTitle}></AlertDialogTitle>
          <AlertDialogDescription {...headerDesc}></AlertDialogDescription>
        </AlertDialogHeader>

        <div
          className="w-full break-words whitespace-pre-line"
          style={{ wordBreak: 'break-word' }}
        >
          {children}
        </div>

        <AlertDialogFooter
          className="mt-2 flex-row items-center justify-center text-base gap-2"
          {...footer}
        >
          {showCancel &&
            <AlertDialogCancel
              onClick={() => handleAction(false)}
              className="mt-0 flex-1 xl:flex-none bg-secondary text-secondary-foreground border-none"
            >{cancelText ?? t('common.cancel')}</AlertDialogCancel>
          }
          <AlertDialogAction
            className="mt-0 flex-1 xl:flex-none bg-primary text-primary-foreground border-none"
            onClick={() => handleAction(true)}
          >{confirmText ?? t('common.confirm')}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

